import styled from 'styled-components'
import { Swiper, SwiperSlide } from 'swiper/react'

export const ThumbnailCarouselContainer = styled.div`
  overflow: visible;
  width: 100%;
`

export const StyledSwiper = styled(Swiper)`
  overflow: visible;
`

export const StyledSwiperSlide = styled(SwiperSlide)<{ $slideWidth: number }>`
  width: ${({ $slideWidth }) => `${$slideWidth}px`};
  overflow: visible;
`
